export default __webpack_public_path__ + "static/launchpad-new-image-36a81cc171be92d16d2bed44c4530569.png";